export const getBtnClass = (type, condition = true) => {
  let className = 'fv-button fv-button--primary';

  if (type == 'next') {
    className += ' fv-cta-next';
  }

  if (type == 'prev') {
    className = 'fv-link fv-link--chevron-left';
  }

  if (type == 'confirmation') {
    className = 'fv-link';
  }

  if (!condition) {
    className += ' is-disabled';
  }

  return className;
};

export const formatLink = (href, location) => {
  let link = href;

  if (location && location.postcode) {
    link += '?postcode=' + location.postcode;

    if (location.address) {
      link += '&address=' + location.address;
    }
  } else if (location && location.lat && location.lon) {
    link += `?lat=${location.lat}&lon=${location.lon}`;
  }

  return link;
};
